import { TReduxActions } from '../../types/redux';

import { EReviewDetailsActionTypes } from '../../actions/reviewsDetails/actions';
import { IReviewsDetails } from '../../types/reviewsDetails';

const defaultState: IReviewsDetails = {
  isOpen: false,
  reviewId: null,
};

export function reviewsDetailsReducer(state: IReviewsDetails = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EReviewDetailsActionTypes.SetReviewReviewDetailsOpen: {
      return {
        isOpen: true,
        reviewId: action.payload.reviewId,
      };
    }

    case EReviewDetailsActionTypes.SetReviewReviewDetailsClose: {
      return {
        isOpen: false,
        reviewId: null,
      };
    }

    default:
      return state;
  }
}
